import { createActions, createReducer } from 'reduxsauce';

export const INITIAL_STATE = {
  fetching: false,
  fetched: false,
  error: null,
  data: [],
};

const { Types, Creators } = createActions(
  {
    updateMembership: ["user_id", "user_type", "membership"],
    updateMembershipRequest: [],
    updateMembershipSuccess: ['data'],
    updateMembershipFailure: ['error'],
  },
  { prefix: 'cb/admin/userManager/updateMembership' },
);

export { Types as types, Creators as actions };

// Reducers
const request = state => ({
  ...state,
  fetching: true,
  fetched: false,
  error: null,
});

const success = (state, action) => ({
  ...state,
  fetching: false,
  fetched: true,
  data: action.data,
});

const failure = (state, action) => ({
  ...state,
  fetching: false,
  fetched: false,
  error: action.error,
});

export const HANDLERS = {
  [Types.UPDATE_MEMBERSHIP_REQUEST]: request,
  [Types.UPDATE_MEMBERSHIP_SUCCESS]: success,
  [Types.UPDATE_MEMBERSHIP_FAILURE]: failure,
};

export default createReducer(INITIAL_STATE, HANDLERS);
